var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessibilityIconElementary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004347"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 128",
    cx: 13,
    cy: 12.5,
    r: 11.5,
    stroke: "#565656",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.0021 8.02568C14.0144 8.02568 14.8374 7.24574 14.8374 6.2853C14.8374 5.32486 14.0144 4.54541 13.0021 4.54541C11.9898 4.54541 11.1668 5.32534 11.1668 6.28579C11.1668 7.24623 11.9892 8.02616 13.0021 8.02616V8.02568ZM18.7697 8.05049L18.7533 8.05341L18.74 8.05633C18.7071 8.06557 18.6743 8.07482 18.6414 8.08406C18.0319 8.25484 15.0729 9.04402 12.9857 9.04402C11.0488 9.04402 8.35555 8.36042 7.49356 8.12736C7.40839 8.09623 7.32014 8.06849 7.23137 8.0466C6.60899 7.89139 6.18262 8.49081 6.18262 9.03769C6.18262 9.58457 6.69725 9.83952 7.21495 10.0259V10.0351L10.3345 10.9581C10.6526 11.0729 10.7378 11.1911 10.7804 11.2938C10.9148 11.6232 10.8066 12.2757 10.7707 12.5024L10.5808 13.9007L9.52898 19.3792C9.5259 19.3948 9.52231 19.4104 9.51923 19.4259L9.51256 19.4663C9.43714 19.9665 9.82401 20.4545 10.5613 20.4545C11.2037 20.4545 11.4885 20.0351 11.6101 19.4634C11.6101 19.4634 12.5275 14.5663 12.9862 14.5663C13.4449 14.5663 14.389 19.4634 14.389 19.4634C14.5136 20.0351 14.7953 20.4545 15.4377 20.4545C16.175 20.4545 16.565 19.9665 16.4865 19.4634C16.4798 19.4201 16.47 19.3797 16.4603 19.3359L15.3951 13.907L15.2053 12.5087C15.0678 11.6947 15.1791 11.4242 15.215 11.3619C15.215 11.3619 15.2181 11.359 15.2181 11.3556C15.254 11.2933 15.4146 11.1537 15.7917 11.0199L18.7179 10.0502C18.7343 10.0473 18.7538 10.041 18.7702 10.0346C19.2946 9.84828 19.819 9.59041 19.819 9.04353C19.819 8.49665 19.3931 7.89382 18.7702 8.04903L18.7697 8.05049Z",
    fill: "#565656"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibilityIconElementary);
export default __webpack_public_path__ + "v10/media/accessibilityIconElementary.906558d0891dcfe6a36909af07a05c6e.svg";
export { ForwardRef as ReactComponent };